<template>
  <div class="animated fadeIn case-map">
    <div class="contacts container-custom">
      <div class="contacts__wrapper">
        <div class="ops__header">
          <div class="ops__title" id="traffic">
            Therapist Maps
          </div>
          <div class="case-map__switch custom-radio">
            <b-form-radio-group
              v-model="switcher"
              :options="[{text: 'Visit Map', value: 'case-map'},{text: 'Heat Map', value: 'heat-map'}]"
              buttons
              size="sm"
            />
          </div>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Contacts',
    data() {
      return {
        switcher: this.$route.name
      }
    },
    watch: {
      switcher(e) {
        this.$router.push(e);
      }
    },
  };
</script>
